module.exports = {"id":"158932","name":"Erkan Zengin","rating":"76","photo":"./data/images/photos/3/158932.png","club":{"name":"Hammarby IF","logo":"./data/images/clubs/HammarbyIF.png"},"positions":["MG","MD"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ErkanZengin0.json
// module id = 1288
// module chunks = 0